import { Sender } from 'xstate';
import {
  Context,
  RequestBody,
  RequestComplete,
  RequestError,
  ResponseBody,
  RequestFn,
  Settings,
} from './types';

import { useFeedbackRequest } from './useFeedbackRequest';

/**
 * Хук, создающий service для отправки рейтинга.
 * Принимает функцию, в которой должны быть указаны category и eno, если есть.
 */
export function useRequestService(request: RequestFn) {
  return function requestService(ctx: Context) {
    return function (send: Sender<RequestError | RequestComplete>) {
      let body: Pick<RequestBody, 'rate' | 'comment'> = {
        rate: Number(ctx.rating),
      };
      if (ctx.comment.length > 0) {
        body.comment = ctx.comment;
      }

      request(body)
        .then((responseBody) => {
          if (responseBody.code === 'SUCCESS') {
            send({ type: 'request_complete' });
          } else {
            send({ type: 'request_error' });
          }
        })
        .catch(() => {
          send({ type: 'request_error' });
        });
    };
  };
}
